export const enum UserDataFormFields {
  PHONE = 'phone',
  EMAIL = 'email',
  NAME = 'name',
}

export type TUserDataFormValues = {
  [UserDataFormFields.PHONE]: string,
  [UserDataFormFields.EMAIL]: string,
  [UserDataFormFields.NAME]: string,
}
